export enum GTMChangeModelImageAction {
  Overview = 'overview',
  OverviewFullScreen = 'overview-full-screen',
  Trim = 'trim',
  Color = 'color',
  Interior = 'interior',
  Checkout = 'checkout',
  Dimension = 'dimension',
}

export enum GTMChangeColorAction {
  BaseColor = 'BaseColor',
  RoofColor = 'RoofColor',
  ColorPack = 'ColorPack',
}

export enum GTMFilterTypeAction {
  BodyType = 'bodyType',
  Fuel = 'fuel',
  GearType = 'gearType',
  Brand = 'brand',
  MinPrice = 'min-price',
  MaxPrice = 'max-price',
}

export enum GTMEventAction {
  ClearFilter = 'clear-filter',
  MobileFilter = 'mobile-filter',
  ModelList = 'model-list',
  ModelNotAvailable = 'model-not-available',
  VariantNotAvailable = 'variant-not-available',
  Configuration = 'configuration',
  Equipment = 'equipment',
  Accessory = 'accessory',
  Checkout = 'checkout',
  BankLoan = 'bankloan',
  Interior = 'interior',
  Close = 'close',
  Submit = 'submit',
  DealersNotLoaded = 'dealers-not-loaded',
  OpenConfigurationStep = 'open-configuration-step',
  CloseConfigurationStep = 'close-configuration-step',
  ExpandEquipmentCategory = 'expand-equipment-category',
  CollapseEquipmentCategory = 'collapse-equipment-category',
  PrivacyPolicyUrl = 'privacy-policy-url',
  Click = 'click',
  Reset = 'reset',
  NoResults = 'no-results',
  Error = 'error',
  Change = 'change',
}

export enum GTMMediaGalleryAction {
  OpenVideoModal = 'open-video-modal',
  OpenOverviewFullScreen = 'open-overview-full-screen',
}
